import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
 
import store from './store/index.js'
import global from './utils/global.js'
import i18n from './i18n'
import VueCountryIntl from 'vue-country-intl';
// import Antd from 'ant-design-vue';
// import 'ant-design-vue/dist/antd.css';
import * as VueGoogleMaps from 'vue2-google-maps';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'animate.css'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import 'vue-country-intl/lib/vue-country-intl.css'
import VueLazyload from 'vue-lazyload'
import WOW from 'wowjs'
import VueMeta from 'vue-meta/dist/vue-meta.common.js'

const errorImage = require('@/assets/images/default.png')
const loadingImage = require('@/assets/images/loading-image.jpg')

Vue.use(ElementUI);
Vue.component(VueCountryIntl.name, VueCountryIntl);
Vue.use(VueMeta)

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: errorImage,
  loading: loadingImage,
  attempt: 3
})

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDBzfTySbnsqMF0xPKxLEswIEQ4AbIIPus',
    libraries: ['places','geometry'],
  },
});

let options = {
  maxSpreadZoom: 1,
  fullscreenEl: false,
  closeEl: true,
  tapToClose: true,
  shareEl: false,
  zoomEl: true,
  counterEl: false,
  arrowEl: true,
  tapToToggleControls: false,
  clickToCloseNonZoomable: true
}
Vue.use(preview, options)

Vue.prototype.$wow = WOW
Vue.config.productionTip = false
Vue.prototype.global = global

document.addEventListener('DOMContentLoaded', (event) => {
  const iconLink = document.getElementById('icon-link');
  if (iconLink) {
    let iconPath = '/favicon.ico';
    iconLink.href = iconPath;
  }
});

router.beforeEach((to, from, next) => {
  if (!to.meta) {
    to.meta = {};
  }
  
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  
  if (to.meta.description) {
    let metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', to.meta.description);
    } else {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      metaDescription.content = to.meta.description;
      document.head.appendChild(metaDescription);
    }
  }
  
  if (to.meta.keywords) {
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', to.meta.keywords);
    } else {
      metaKeywords = document.createElement('meta');
      metaKeywords.name = 'keywords';
      metaKeywords.content = to.meta.keywords;
      document.head.appendChild(metaKeywords);
    }
  }
  
  if (to.meta.canonical) {
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.setAttribute('href', to.meta.canonical);
    } else {
      canonicalLink = document.createElement('link');
      canonicalLink.rel = 'canonical';
      canonicalLink.href = to.meta.canonical;
      document.head.appendChild(canonicalLink);
    }
  }
  
  next();
});

router.afterEach((to) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  
  if (to.meta.description) {
    let metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', to.meta.description);
    }
  }
  
  if (to.meta.keywords) {
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', to.meta.keywords);
    }
  }
  
  if (to.meta.canonical) {
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.setAttribute('href', to.meta.canonical);
    }
  }
});

new Vue({
  el:'#app',
  router,
  store,
  i18n,
  render: h => h(App),
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  }
})
